import DashboardRewards from './DashboardRewards';

export default DashboardRewards;
